import React from 'react';
import { Card } from 'semantic-ui-react';
import ContractTasksTable from '../../components/ContractTasksTable';
import ContractAccountsTable from '../../components/ContractAccountsTable';
import ContractNotifyTable from '../../components/ContractNotifyTable';

const Contract = () => {
  return (
    <div className='dashboard-container'>
      <Card fluid className='chart-card'>
        <Card.Content>
          <Card.Header className='header'>合同签署任务</Card.Header>
          <ContractTasksTable />
        </Card.Content>
      </Card>
      <Card fluid className='chart-card' style={{ marginTop: '16px' }}>
        <Card.Content>
          <Card.Header className='header'>合同账号（电子签账号托管）</Card.Header>
          <ContractAccountsTable />
        </Card.Content>
      </Card>
      <Card fluid className='chart-card' style={{ marginTop: '16px' }}>
        <Card.Content>
          <Card.Header className='header'>合同回调记录</Card.Header>
          <ContractNotifyTable />
        </Card.Content>
      </Card>
    </div>
  );
};

export default Contract;
